import { ThemeService } from '../../services/theme.service';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { SidebarService } from '../../services/sidebar.service';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

declare let gtag: Function;
@Component({
  selector: 'app-master-layout',
  templateUrl: './master-layout.component.html',
  styleUrls: ['./master-layout.component.css'],
})
export class MasterLayoutComponent implements OnDestroy, OnInit {
  // tslint:disable-next-line: indent
  public themeClass: string = 'theme-blue';
  smallScreenMenu: string;
  public darkClass: string = '';
  isStopLoading = false;
  currentActiveMenu: string;
  currentActiveSubMenu: string;
  navTab: string = 'member'; // Default navigation tab
  showNotifMenu: boolean;
  showToggleMenu: boolean;
  sidebarStatus: boolean = false;
  private unSubscribeAll$: Subject<void> = new Subject<void>();

  get sidebarVisible(): boolean {
    return this.sidebarService.sidebarVisible;
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private themeService: ThemeService,
    private sidebarService: SidebarService
  ) {
    // subscribe to router events and send page views to Google Analytics
    this.router.events
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // gtag('set', 'page', event.urlAfterRedirects);
          // gtag('send', 'pageview');
        }
      });

    this.activatedRoute.url
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((url) => {
        this.isStopLoading = false;
        this.getActiveRoutes();
      });

    this.themeService.themeClassChange
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((themeClass) => {
        this.themeClass = themeClass;
      });

    this.themeService.smallScreenMenuShow
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((showMenuClass) => {
        this.smallScreenMenu = showMenuClass;
      });

    this.themeService.darkClassChange
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((darkClass) => {
        this.darkClass = darkClass;
      });
  }
  ngOnDestroy(): void {
    if (this.unSubscribeAll$) {
      this.unSubscribeAll$.next();
      this.unSubscribeAll$.complete();
    }
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((event) => this.titleService.setTitle(event['title']));

    this.themeService.themeClassChange
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((themeClass) => {
        this.themeClass = themeClass;
      });

    this.smallScreenMenu = this.themeService.smallScreenMenu;
    this.isStopLoading = true;
    this.getActiveRoutes();
  }

  // subscribeToSidebarStatus(): void {
  //   this.sidebarService.sidebarVisible;
  // }

  getActiveRoutes() {
    const segments: Array<string> = this.router.url.split('/');
    this.currentActiveMenu = segments[2];
    this.currentActiveSubMenu = segments[3];
  }
  toggleNotificationDropMenu() {
    this.showNotifMenu = !this.showNotifMenu;
  }

  toggleSettingDropMenu() {
    this.showToggleMenu = !this.showToggleMenu;
  }

  activeInactiveMenu($event) {
    if ($event.item && $event.item === this.currentActiveMenu) {
      this.currentActiveMenu = '';
    } else {
      this.currentActiveMenu = $event.item;
    }
  }
}
